export enum Point {
  Negative = "Negative",
  Neutral = "Neutral",
  Positive = "Positive"
}

export enum AnswerType {
  Project = "Project",
  Growth = "Growth",
  Network = "Network",
  Rotation = "Rotation"
}

export enum RotationTerm {
  Months_3 = "Months_3",
  Months_6 = "Months_6",
  Months_9 = "Months_9"
}

export interface INewAnswerRepresentation {
  accountId?: string;
  answerType: AnswerType;
  qualitative: string;
  quantitative: Point;
  rotationTerm: RotationTerm;
}

export interface IAnswerHypermediaRepresentation {
  accountId: string;
  accountName: string;
  answerType: AnswerType;
  qualitative: string;
  quantitative: Point;
  rotationTerm: RotationTerm;
  _links: {};
  _actions: {};
}

export interface IAnswerDatum {
  snapshotId: number;
  d: string;
  v: Point;
}
